import React from 'react';

import { Field } from 'react-final-form';
import { RenderField } from 'forms';

export interface Props {
    name: string;
    validate?: any;
}

export default function FertilizerEventProductUnitsPerAreaField(
    props: Props
): React.ReactElement | null {
    const { name, validate } = props;

    return (
        <Field
            name={`${name}.units`}
            component={RenderField as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            label="Rate"
            type="number"
            nullOnUnmount={false}
            validate={validate}
        />
    );
}
